module.exports = __webpack_public_path__ + "static/segunda meetup-00e716a28db6643dd90fa775d684dd67.jpg";